import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getSelectedOptionFromField } from 'utilities'
import FileUpload from './FileUpload'
import { DumbField } from '../Field'
import orderBy from 'lodash/orderBy'
import { uploadFile } from './FileUpload'
import store from '../../../store'
import { setUploading } from '../WizardActions'
// import ReactMarkdown from 'components/Markdown/Markdown'
import { resolveFieldConditions } from '@tecuity/wizard-utilities'

class UploadAccumulator extends Component {
  componentDidMount = () => {
    if (!this.props.viewOnly) this.calculateQueue()
  }
  //Checks if the number of uploads has changed, and calculates a fresh queue if they have.
  componentDidUpdate = (prevProps) => {
    if (!this.props.viewOnly) {
      if (
        this.getCurrentQueueFromValueObject(this.props.value).length >
        this.getCurrentQueueFromValueObject(prevProps.value).length
      ) {
        this.calculateQueue()
      }
    }
  }
  //Calculates a fresh queue and decides if the queue needs to start an upload session.
  calculateQueue = () => {
    const uploadQueue = this.getCurrentQueueFromValueObject(this.props.value)
    const numPending = this.getNumByStatus(uploadQueue, 'pending')

    if (!this.props.uploading && numPending > 0) {
      this.props.setUploading(true)
      this.startQueue(uploadQueue)
    }
  }
  //Takes in a queue and a status and returns the number of files with the given status.
  getNumByStatus = (queue, status) => {
    return queue.reduce((num, file) => (file.status === status ? num + 1 : num), 0)
  }
  //Takes in a queue array, sets each file status to "uploading", and starts each upload.
  startQueue = (queue) => {
    queue = queue.filter((file) => file.status === 'pending').slice(0, 6)

    queue.forEach((fileObj) => {
      this.props.onChange(
        this.getUploadGroupByFieldId(fileObj.fieldId, fileObj.queueId, { status: 'uploading' }),
      )
    })
    queue.forEach((fileObj) => {
      this.startFileUpload(fileObj)
    })
  }
  //Takes in a file object and starts an upload.
  startFileUpload = (fileObj) => {
    // console.log("%c Started uploading: " + fileObj.file.name, 'background: rgb(0, 140, 255); padding: 2px; border-radius: 3px;')
    this.props.onChange(
      this.getUploadGroupByFieldId(fileObj.fieldId, fileObj.queueId, { status: 'uploading' }),
    )
    uploadFile(
      fileObj.file,
      { IMAGE_DATA_TYPE_ID: fileObj.imageTypeId, SORT_ORDER: fileObj.sortOrder || 0 },
      (e) => {
        if (e.lengthComputable) {
          var progress = (e.loaded / e.total) * 100
          this.props.onChange(
            this.getUploadGroupByFieldId(fileObj.fieldId, fileObj.queueId, { progress }),
          )
          // console.log("%c Successfully uploaded: " + fileObj.file.name, 'background: rgb(102, 213, 63); padding: 2px; border-radius: 3px;')
        }
      },
      fileObj,
    )
      .then((guid) => {
        this.props.onChange(
          this.getUploadGroupByFieldId(fileObj.fieldId, fileObj.queueId, {
            status: 'success',
            guid,
          }),
        )
        this.checkForAndRunNextItemInQueue()
      })
      .catch((err) => {
        console.log('Got error: ', err)
        this.props.onChange(
          this.getUploadGroupByFieldId(fileObj.fieldId, fileObj.queueId, { status: 'failed' }),
        )
        this.checkForAndRunNextItemInQueue()
      })
  }
  //Gets a fresh queue, and checks if there's still files to upload. Starts the next item otherwise it closes the upload session.
  checkForAndRunNextItemInQueue = () => {
    const queue = this.getCurrentQueueFromValueObject(
      getFreshValueFromStoreByParent(this.props.parent, this.props.fieldId),
    )
    const numPending = this.getNumByStatus(queue, 'pending')
    if (numPending > 0) {
      this.startFileUpload(this.getNextItemInQueue(queue))
    } else {
      this.props.setUploading(false)
    }
  }
  //Returns the first item in the queue array with status, "pending"
  getNextItemInQueue = (queue) => {
    return queue.find((file) => file.status === 'pending')
  }
  //Takes in a fieldId, a queueId, and a payload object to be spread into the file with the given queueId, and returns the full value object.
  getUploadGroupByFieldId = (fieldId, queueId, payload = {}) => {
    const freshValue = getFreshValueFromStoreByParent(this.props.parent, this.props.fieldId)
    const fileIndex = freshValue[fieldId].findIndex((file) => file.queueId === queueId)
    const file = {
      ...freshValue[fieldId][fileIndex],
      ...payload,
    }
    const files = [
      ...freshValue[fieldId].slice(0, fileIndex),
      file,
      ...freshValue[fieldId].slice(fileIndex + 1),
    ]
    return {
      ...freshValue,
      [fieldId]: files,
    }
  }
  //Updates the value object in the store with uploads from a FileUpload component.
  collectUpload = (value, e) => {
    const fieldId = e.target.name
    this.props.onChange({ ...this.props.value, [fieldId]: value }, {})
  }
  //Returns a freshly constructed and sorted queue by getting the fresh value from the store.
  getFreshQueue = () => {
    return this.getCurrentQueueFromValueObject(
      getFreshValueFromStoreByParent(this.props.parent, this.props.fieldId),
    )
  }
  //Takes in a value object and returns a sorted queue.
  getCurrentQueueFromValueObject = (value) => {
    const queue = Object.keys(value).reduce((array, fieldId) => [...array, ...value[fieldId]], [])
    return orderBy(queue, ['queuePosition'], ['asc'])
  }
  render() {
    const { uploads, viewOnly, value = {}, errorMessage, disabled } = this.props
    const errors = errorMessage ? errorMessage[0] : false
    return (
      <div>
        {viewOnly ? (
          <div className="block-wrapper">
            {uploads.map((upload) => (
              <div className="field" key={upload.fieldId}>
                <span className="field-label">{upload.label}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className="block-wrapper">
            {uploads.map((upload) => (
              <DumbField
                {...upload}
                errorMessage={errors && errors[upload.fieldId] ? errors[upload.fieldId].errors : []}
                isValid={errors && errors[upload.fieldId] ? errors[upload.fieldId].isValid : null}
                description=" "
                key={upload.fieldId}
              >
                <FileUpload
                  {...upload}
                  value={value[upload.fieldId]}
                  onChange={this.collectUpload}
                  parent={{ id: this.props.fieldId, type: 'UploadAccumulator' }}
                  key={upload.fieldId}
                  disabled={disabled}
                />
              </DumbField>
            ))}
          </div>
        )}
      </div>
    )
  }
}
export default connect(
  (state) => ({
    uploads: getUploadsFromFields(state.wizard.wizard.fields),
    fields: state.wizard.wizard.fields,
    uploading: state.wizard.uploading,
  }),
  { setUploading },
)(UploadAccumulator)

//Takes in the current fields object, and returns a filtered array of uploadPlaceholder fields.
export const getUploadsFromFields = (fields) => {
  //Convert fields object to an array
  const fieldsArray = Object.keys(fields).map((fieldId) => fields[fieldId])
  //Filter out everything except upload placeholder that have satisified their conditions.
  const uploadFields = fieldsArray.filter(
    (field) =>
      field.type === 'UploadPlaceholder' &&
      field.active &&
      resolveFieldConditions(field.conditions, fields, field.conditionsOperator),
  )
  //Filter out dependent upload placeholders that aren't visible.
  const filteredFields = uploadFields.filter((field) => {
    switch (field.parent.type.toUpperCase()) {
      case 'SECTION':
        return true
      case 'OPTION': {
        const parentField = fields[field.parent.id]
        const selectedOption = getSelectedOptionFromField(parentField, null)
        if (selectedOption) {
          const selectedOptionHasUploadPlaceholder = selectedOption.fields.find(
            (fieldId) => fieldId === field.fieldId,
          )
          if (selectedOptionHasUploadPlaceholder) return true
          else return false
        } else return false
      }
      case 'CHECKBOX': {
        const parentField = fields[field.parent.id]
        const currentCheckboxValueFields =
          parentField.value === true ? parentField.checkedFields : parentField.uncheckedFields
        const currentCheckStateHasUploadPlaceholder = currentCheckboxValueFields.find(
          (fieldId) => fieldId === field.fieldId,
        )
        if (currentCheckStateHasUploadPlaceholder) return true
        return false
      }
      case 'REPEATER': {
        const parentField = fields[field.parent.id]
        return (
          parentField.active &&
          resolveFieldConditions(parentField.conditions, fields, parentField.conditionsOperator)
        )
      }
      default:
        return false
    }
  })
  //Find all upload placeholders that are children of repeaters.
  const placeholdersInRepeaters = uploadFields.filter(
    (field) => field.parent.type.toUpperCase() === 'REPEATER',
  )
  //Loop through each row of the parent repeater and return an array of dummy upload placeholders
  const calculatedRepeaterPlaceholders = placeholdersInRepeaters.reduce(
    (calculated, placeholder, i) => {
      const parent = fields[placeholder.parent.id]
      return [
        ...calculated,
        ...parent.value.map((row, k) => ({
          ...placeholder,
          label: placeholder.label + ' for row number ' + (k + 1),
          name: placeholder.name + row._rowId,
          fieldId: placeholder.fieldId + row._rowId,
        })),
      ]
    },
    [],
  )
  //Combine the repeater placeholders with all the other placeholders
  const combinedFields = [...filteredFields, ...calculatedRepeaterPlaceholders]
  return combinedFields
}

const getFreshValueFromStoreByParent = (parent, ownFieldId) => {
  if (parent.type === 'UploadAndSubmit') {
    return store.getState().wizard.wizard.fields[parent.id].value.files
  } else {
    return store.getState().wizard.wizard.fields[ownFieldId].value
  }
}
